import React from 'react';

export interface WhiteBackgroundProps {
	content?: React.ReactElement;
	children?: React.ReactNode;
	noMargin?: boolean;
	className?: string;
}
export const WhiteBackground = ({ content, children, noMargin = false, className }: WhiteBackgroundProps) => {
	return <div className={`white-background ${noMargin ? 'no-margin' : ''} ${className}`}>{children ?? content}</div>;
};
